<template>
    <div class="capacity-widget" :class="'capacity-' + (data ? data.status : 'loading')">
        <div v-if="loading" class="text-muted">
            <i class="fa fa-spinner fa-spin"></i> Loading capacity…
        </div>
        <div v-else-if="!data" class="text-muted">
            <small>Capacity data unavailable</small>
        </div>
        <div v-else>
            <div>
                <span class="label" :class="badgeClass">{{ statusLabel }}</span>
                <span v-if="data.deadline" class="text-muted">
                    &nbsp; before {{ data.deadline }}
                </span>
            </div>
            <div class="text-muted" style="margin-top: 4px;">
                <small>{{ data.message }}</small>
            </div>
            <div v-if="data.status !== 'unknown'" style="margin-top: 6px; font-size: 0.85em;">
                <strong>{{ (data.mins_required / 60).toFixed(1) }}h</strong> needed
                of <strong>{{ (data.net_minutes_available / 60).toFixed(1) }}h</strong> net free
                — {{ data.utilization_percent }}% utilisation
            </div>
        </div>
    </div>
</template>

<script>
/*
    Block 2 capacity widget. Fetches from /api/signoff/{quote}/capacity
    and renders the green/amber/red status with the algorithm's
    breakdown numbers so Kev can sanity-check.

    See planning/quote-signoff-design.md §5.1.
*/
export default {
    props: {
        quoteId: { type: [String, Number], required: true },
    },
    data() {
        return { loading: true, data: null };
    },
    mounted() { this.refresh(); },
    watch: {
        quoteId() { this.refresh(); },
    },
    computed: {
        badgeClass() {
            const map = {
                green:   'label-success',
                amber:   'label-warning',
                red:     'label-danger',
                unknown: 'label-default',
            };
            return this.data ? map[this.data.status] : 'label-default';
        },
        statusLabel() {
            const map = {
                green:   'Green',
                amber:   'Amber',
                red:     'Red',
                unknown: 'Unknown',
            };
            return this.data ? map[this.data.status] : '';
        },
    },
    methods: {
        refresh() {
            this.loading = true;
            fetch(`/api/signoff/${this.quoteId}/capacity`, { headers: { Accept: 'application/json' }})
                .then(r => r.json())
                .then(d => { this.data = d; this.loading = false; })
                .catch(() => { this.loading = false; });
        },
    },
};
</script>
